import { useMutation, useQueryClient } from '@tanstack/react-query'
import { assert } from '@/utils'
import { IBCTransferStatus, traceIbcStatus2 } from '@/wallet-utils'
import { queryKeys } from '@/query-keys'
import { MutationParameters } from './types'

// [sign/broadcast] mutations and [trace] mutation are a 2-part process.
// First, if [sign/broadcast] doesn't succeed within the UI time limit, [trace] mutation will continue
// the [tracing] process so user can continue when the ibc transfer completes if they haven't closed the modal yet.
// We can use the `isLoading` status provided by [trace] mutation to display the "Return Later" screen.
const useTraceIbcTransfer = ({ withdrawStTokenTransaction }: MutationParameters) => {
  const client = useQueryClient()

  return useMutation({
    mutationFn: async (): Promise<{ status: IBCTransferStatus }> => {
      assert(withdrawStTokenTransaction, 'Unable to trace ibc status while transaction is empty.')

      // Continue tracing without timeout so user can complete when ready
      const status = await traceIbcStatus2({ denom: 'STRD', tx: withdrawStTokenTransaction }, { timeout: false })

      await Promise.all([
        client.invalidateQueries({
          queryKey: queryKeys.transactionHistoryIbcStatusByHash({ hash: withdrawStTokenTransaction.transactionHash })
        }),
        client.invalidateQueries({ queryKey: queryKeys.chainBalancesBase })
      ])

      return { status }
    }
  })
}

export { useTraceIbcTransfer }
